// extracted by mini-css-extract-plugin
module.exports = {"trademe-icon":"Ho2N7u9MBELEq96ckfHB3","selling-points":"UNYANS950lIiaZTJl7YNg","preLoaderShimmer":"uIE6L9SxXVBnmvodPVAvv"};